import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router';
import { useAnalytics } from '../hooks';

export const NotFoundRedirect = () => {
  const location = useLocation();
  const analytics = useAnalytics();

  useEffect(() => {
    analytics.capture('navigation:not_found_redirect_send', {
      path: location.pathname,
      url: location.pathname,
    });
  }, [location, analytics]);

  return <Navigate to="/" replace />;
};
